"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
var jsx_runtime_1 = require("react/jsx-runtime");
var styled_components_1 = require("styled-components");
var useWindowDimensions_1 = require("../../hooks/useWindowDimensions");
var Loading_1 = require("../Loading");
var LoadingChart = function () {
    var width = (0, useWindowDimensions_1.useWindowDimensions)().width;
    return ((0, jsx_runtime_1.jsx)(LoadingArea, __assign({ width: width }, { children: (0, jsx_runtime_1.jsx)(Loading_1["default"], {}) })));
};
var LoadingArea = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: ", "px;\n"], ["\n  height: ", "px;\n"])), function (props) { return props.width / 3; });
exports["default"] = LoadingChart;
var templateObject_1;
